import { Icon } from "./Icon.tsx";

/** "Fetch from a remote source" icon — used by the "Fetch from AEMET" button (EditSubBasinDialog.tsx), a cloud with a download arrow. */
export function CloudDownloadIcon() {
  return (
    <Icon>
      <path d="M7 18a4.5 4.5 0 0 1-1-8.9 5.5 5.5 0 0 1 10.6-2A4.5 4.5 0 0 1 17 18H7Z" />
      <path d="M12 10v8" />
      <path d="M9 15l3 3 3-3" />
    </Icon>
  );
}
